import localization from '../../../shared/strings';
import Toast from '../../../components/Toast';
import { navigate } from '../../../helpers/history';
import { OPERATION_TYPES, RESULT } from '../constants';
import formatOperationToastHtml from './formatOperationToastHtml';
import mapOperationLabel from './mapOperationLabel';

const l10n = localization.TOAST.OPERATIONS;
const AUTO_CLOSE_MS = 8000;

const CHANNEL_PROGRESS = {
  [OPERATION_TYPES.ARCHIVE_CHANNEL_RECORDS]: 'archived in',
  [OPERATION_TYPES.DELETE_FROM_CHANNEL]: 'deleted from',
};

export default function showBatchOperationStartedToast({
  batchId,
  status,
  total,
  operationType,
  channelName,
} = {}) {
  if (!batchId) return;
  if (status !== RESULT.queued && status !== RESULT.running) return;

  const label = mapOperationLabel(operationType);
  const count = typeof total === 'number' ? total : 0;
  const title = l10n.startedTitle(label);
  const body = l10n.startedBody(count, channelName, CHANNEL_PROGRESS[operationType]);

  Toast(formatOperationToastHtml(title, body), {
    autoClose: AUTO_CLOSE_MS,
    btnOkValue: l10n.viewOperation,
    onOk: () => navigate(`/operations?id=${batchId}`),
  });
}
